import Image from 'next/image';
import s from './IconList.module.css';
import { IconListProps } from '@/types/model';
import { usePathname } from 'next/navigation';
import useIsMobile from '@/hooks/use-is-mobile';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import rehypeRaw from 'rehype-raw';
import { ImageLoader } from '@/lib/imageLoader';
import { ReactSVG } from 'react-svg';
import { hideDecorativeSvg } from '@/lib/a11y';
import cs from 'classnames';
import { motion } from 'framer-motion';

const IconList = ({ items }: IconListProps) => {
  const pathname = usePathname();
  const isMobile = useIsMobile();

  const columns_classnames = cs(s.container__items, {
    [s.container__items__4_col]: !pathname.includes('/amenidades'),
    [s.container__items__3_col]: pathname.includes('/referidos')
  });

  const containerClassname = cs(s.container, {
    [s.container__ref]: pathname.includes('/referidos')
  });

  return (
    <div className={containerClassname}>
      {pathname.includes('/parques-y-areas-verdes') && (
        <div className={s.container__map}>
          <Image
            src={isMobile ? '/images/masterplan-mob.jpg' : '/images/masterplan-desktop.jpg'}
            alt="imagen-representativa"
            width={isMobile ? 350 : 1010}
            height={isMobile ? 140 : 350}
            quality={65}
            sizes={isMobile ? '350px' : '1010px'}
          />
        </div>
      )}
      <div className={columns_classnames}>
        {items.map((item, index) => (
          <motion.div
            whileInView={{ opacity: [0, 1], transition: { duration: 2, delay: (index + 1) / 5 } }}
            key={item.label}
            className={s.container__items__item}>
            <div className={s.container__items__item__icon}>
              <ReactSVG
                className={s.container__items__item__icon__svg_container}
                src={ImageLoader({ src: item.icon?.url })}
                beforeInjection={hideDecorativeSvg}
              />
            </div>
            <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkBreaks]}>
              {item.label}
            </ReactMarkdown>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default IconList;
